module.exports = __webpack_public_path__ + "0df30ee8c50c858417a9fb609f25a81f.pdf";